(function () {
  'use strict';

  /* ==========================================================
     CONFIG
  ========================================================== */

  const INVENTORY_API =
    'https://api.bombayhair.ca/pro/inventory-quantity/product';

  const EXCLUDED_PRODUCT_IDS = new Set([
    '7966329602201',
    '7966349852825',
    '7966349918361'
  ]);

  const BACKORDER_TEXT = 'Backorder: Ships Once In Stock';
  const LOW_STOCK_TEXT = 'Less than 4 In Stock';

  const OLD_PICKER =
    '.ib-prod-varient-backorder-flex .product-container-backorder';

  const CUSTOM_PICKER =
    '.ib-custom-product-variant-picker-color-swatch';

  const CUSTOM_INPUT =
    '.ib-custom-product-variant-picker-color-swatch__input';

  let productId = null;
  let productInventory = null;
  let inventoryLoaded = false;
  let customInventoryLoaded = false;

  let productRequest = null;
  let customLengthRequest = null;

  let lastVariantId = null;
  let lastQuantity = null;

  /* ==========================================================
     HELPERS
  ========================================================== */

  function getProductId() {
    const element = document.querySelector(
      '#product-right [data-backorder-current-product-id]'
    );

    const id = element?.getAttribute(
      'data-backorder-current-product-id'
    );

    return id && /^\d+$/.test(id) ? String(id) : null;
  }

  function isExcludedProduct() {
    return EXCLUDED_PRODUCT_IDS.has(String(productId));
  }

  function getInventoryQuantity(variantId) {
    if (!inventoryLoaded || !productInventory || !variantId) {
      return null;
    }

    const key = String(variantId);

    if (!Object.prototype.hasOwnProperty.call(productInventory, key)) {
      return null;
    }

    const quantity = Number(productInventory[key]);

    return Number.isFinite(quantity) ? quantity : null;
  }

  async function fetchInventory(productIds) {
    const ids = [...new Set(
      productIds
        .map(id => String(id || '').trim())
        .filter(id => /^\d+$/.test(id))
    )];

    if (!ids.length) return {};

    const response = await fetch(INVENTORY_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ productIds: ids })
    });

    if (!response.ok) {
      throw new Error('Inventory API error: ' + response.status);
    }

    return response.json();
  }

  function getProductFormVariantId() {
    const forms = document.querySelectorAll(
      'form[action*="/cart/add"]'
    );

    for (const form of forms) {
      const input = form.querySelector('[name="id"]');

      if (input?.value) {
        return String(input.value);
      }
    }

    return null;
  }

  function getUrlVariantId() {
    return new URLSearchParams(location.search).get('variant');
  }

  /* ==========================================================
     OLD PRO PICKER
  ========================================================== */

  function getOldPickerVariantId() {
    const input = document.querySelector(
      OLD_PICKER + ' input:checked'
    );

    if (!input) return null;

    const container = input.closest(
      '.product-container-backorder'
    );

    const element = container?.querySelector(
      '[data-length-swatch-variant-id]'
    );

    return element?.getAttribute(
      'data-length-swatch-variant-id'
    ) || null;
  }

  function updateOldPickerLabels() {
    if (!inventoryLoaded || isExcludedProduct()) return;

    document.querySelectorAll(OLD_PICKER).forEach(option => {
      const element = option.querySelector(
        '[data-length-swatch-variant-id]'
      );

      if (!element) return;

      const variantId = element.getAttribute(
        'data-length-swatch-variant-id'
      );

      const quantity = getInventoryQuantity(variantId);

      // Inventory may not be available for this variant yet.
      // Do not change the existing label when the quantity is unknown.
      if (quantity === null) return;

      let label = option.querySelector(
        '.ib-inside-length-backorder'
      );

      if (quantity <= 0) {
        if (!label) {
          label = document.createElement('span');
          label.className = 'ib-inside-length-backorder';
          label.textContent = ' (Backorder) ';
          option.appendChild(label);
        }

        option.classList.add('ibat-below-btm');
      } else {
        label?.remove();
        option.classList.remove('ibat-below-btm');
      }
    });
  }

  /* ==========================================================
     NEW CUSTOM PICKER
     Read product variants JSON embedded in the picker.
  ========================================================== */

  function getCustomPickerData() {
    const picker = document.querySelector(CUSTOM_PICKER);

    if (!picker) return null;

    const jsonElement = picker.querySelector(
      'script[type="application/json"]'
    );

    if (!jsonElement) return null;

    try {
      const variants = JSON.parse(jsonElement.textContent);

      return Array.isArray(variants)
        ? { picker, variants }
        : null;
    } catch (error) {
      console.error(
        'Unable to parse picker variant data:',
        error
      );

      return null;
    }
  }

  function getSelectedCustomOptions(picker) {
    const fieldsets = [
      ...picker.querySelectorAll(
        '.ib-custom-product-variant-picker-color-swatch__fieldset'
      )
    ];

    const selectedValues = [];

    for (const fieldset of fieldsets) {
      const input = fieldset.querySelector(
        CUSTOM_INPUT + ':checked'
      );

      if (!input) return null;

      selectedValues.push(input.value);
    }

    return selectedValues;
  }

  function getMatchingCustomVariant() {
    const data = getCustomPickerData();

    if (!data) return null;

    const selectedOptions = getSelectedCustomOptions(data.picker);

    if (!selectedOptions) return null;

    return data.variants.find(variant =>
      Array.isArray(variant.options) &&
      variant.options.length === selectedOptions.length &&
      variant.options.every(
        (value, index) => value === selectedOptions[index]
      )
    ) || null;
  }


function getSelectedVariantId() {
  // 1. Try the custom picker when it exists.
  if (document.querySelector(CUSTOM_PICKER)) {
    const matchingVariant = getMatchingCustomVariant();

    if (matchingVariant?.id) {
      return String(matchingVariant.id);
    }
  }

  // 2. Try the selected legacy PRO length option.
  const oldId = getOldPickerVariantId();

  if (oldId) {
    return String(oldId);
  }

  // 3. Try the product form's current variant ID.
  const formId = getProductFormVariantId();

  if (formId) {
    return String(formId);
  }

  // 4. Last fallback: variant in the URL.
  const urlId = getUrlVariantId();

  return urlId ? String(urlId) : null;
}


  function updateCustomPickerLabels() {
    if (isExcludedProduct()) return;

    const data = getCustomPickerData();

    if (!data || !inventoryLoaded || !productInventory) return;

    const selectedOptions = getSelectedCustomOptions(data.picker);

    if (!selectedOptions) return;

    const fieldsets = [
      ...data.picker.querySelectorAll(
        '.ib-custom-product-variant-picker-color-swatch__fieldset'
      )
    ];

    fieldsets.forEach((fieldset, optionIndex) => {
      const legend = fieldset.querySelector(
        '.ib-custom-product-variant-picker-color-swatch__legend'
      );

      const optionName = legend?.textContent.toLowerCase() || '';

      if (
        !optionName.includes('length') &&
        !optionName.includes('size')
      ) {
        return;
      }

      const options = fieldset.querySelectorAll(
        '.ib-custom-product-variant-picker-color-swatch__option'
      );

      options.forEach(option => {
        const input = option.querySelector(CUSTOM_INPUT);

        if (!input) return;

        /*
          Match this length against the currently selected values
          for all other options.
        */

        const matchingVariants = data.variants.filter(variant =>
          Array.isArray(variant.options) &&
          variant.options[optionIndex] === input.value &&
          variant.options.every(
            (value, index) =>
              index === optionIndex ||
              value === selectedOptions[index]
          )
        );

        const matchingQuantities = matchingVariants
          .map(variant => getInventoryQuantity(variant.id))
          .filter(quantity => quantity !== null);

        option.classList.remove('is-backorder');

        if (
          matchingQuantities.length &&
          matchingQuantities.every(quantity => quantity <= 0)
        ) {
          option.classList.add('is-backorder');
        }
      });
    });
  }

  /* ==========================================================
     MAIN BACKORDER NOTICE
  ========================================================== */

  function removeMainNotice() {
    document.querySelectorAll('.ibat-backorder').forEach(
      element => element.remove()
    );

    const selection = document.querySelector(
      '.ibat-your-selection'
    );

    if (selection) {
      selection.classList.add('ibat-without-backorder');
    }
  }

  function renderMainNotice(quantity) {
    const addToCart = document.querySelector(
      '.add-to-cart-wrapper'
    );

    const selection = document.querySelector(
      '.ibat-your-selection'
    );

    /*
      Return false if the Add to Cart wrapper is not ready.
      A later scheduled update can try again.
    */

    if (!addToCart || !Number.isFinite(quantity)) {
      return false;
    }

    let message = '';

    if (quantity <= 0) {
      message = BACKORDER_TEXT;
    } else if (quantity <= 4) {
      message = LOW_STOCK_TEXT;
    }

    let notice = document.querySelector('.ibat-backorder');

    if (!message) {
      removeMainNotice();
      return true;
    }

    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'ibat-backorder';

      const span = document.createElement('span');

      notice.appendChild(span);

      addToCart.insertAdjacentElement(
        'beforebegin',
        notice
      );
    }

    const span = notice.querySelector('span');

    if (span && span.textContent !== message) {
      span.textContent = message;
    }

    if (selection) {
      selection.classList.remove('ibat-without-backorder');
    }

    return true;
  }


function updateMainBackorderMessage() {
  if (!inventoryLoaded) return;

  if (isExcludedProduct()) {
    removeMainNotice();
    return;
  }

  const variantId = getSelectedVariantId();
  if (!variantId) return;

  const quantity = getInventoryQuantity(variantId);
  if (quantity === null) return;

  // Attempt rendering before caching the variant.
  const rendered = renderMainNotice(quantity);

  if (!rendered) return;

  lastVariantId = String(variantId);
  lastQuantity = quantity;
}


  function updateAllLabels() {
    updateOldPickerLabels();
    updateCustomPickerLabels();
  }

  /* ==========================================================
     LOAD MAIN PRODUCT INVENTORY ONCE
  ========================================================== */





function loadInventory() {
  if (productRequest) return productRequest;

  productRequest = fetchInventory([productId])
    .then(data => {
      productInventory = data[productId] || {};
      inventoryLoaded = true;

      function refreshBackorderUI() {
        updateAllLabels();
        updateMainBackorderMessage();
      }

      // Render immediately after inventory becomes available.
      refreshBackorderUI();

      // Retry only while the main notice has not appeared.
      const retryDelays = [100, 300, 600, 1200, 2000];

      retryDelays.forEach(delay => {
        setTimeout(() => {
          if (!document.querySelector('.ibat-backorder')) {
            refreshBackorderUI();
          }
        }, delay);
      });

      return data;
    })
    .catch(error => {
      productRequest = null;
      console.error('Unable to load product inventory:', error);
      return null;
    });

  return productRequest;
}





  /* ==========================================================
     CUSTOM LENGTH PRODUCTS
     Only one request; never overwrite a variant-specific notice.
  ========================================================== */

  function loadCustomLengthInventory() {
    if (customLengthRequest) return customLengthRequest;

    const elements = [
      ...document.querySelectorAll(
        '.ibat-length-variant li.ibat-length-variant'
      )
    ];

    if (!elements.length) return Promise.resolve(null);

    const ids = elements
      .map(element =>
        element.getAttribute('data-prodid-custom-length')
      )
      .filter(Boolean);

    if (!ids.length) return Promise.resolve(null);

    customLengthRequest = fetchInventory(ids)
      .then(data => {
        customInventoryLoaded = true;

        elements.forEach(element => {
          const id = String(
            element.getAttribute('data-prodid-custom-length') || ''
          );

          const inventory = data[id];

          if (!inventory) return;

          const quantity = Number(
            Object.values(inventory)[0]
          );

          if (!Number.isFinite(quantity)) return;

          let label = element.querySelector(
            '.ib-inside-length-backorder'
          );

          if (quantity <= 0) {
            if (!label) {
              label = document.createElement('span');
              label.className = 'ib-inside-length-backorder';
              label.textContent = ' (Backorder) ';
              element.appendChild(label);
            }
          } else {
            label?.remove();
          }
        });

        /*
          For products without a variant picker only, use the
          current product's inventory from this response.
        */

        const hasPicker = document.querySelector(
          OLD_PICKER + ', ' + CUSTOM_PICKER
        );

        if (!hasPicker && data[productId]) {
          const quantity = Number(
            Object.values(data[productId])[0]
          );

          if (Number.isFinite(quantity)) {
            renderMainNotice(quantity);
          }
        }

        return data;
      })
      .catch(error => {
        customLengthRequest = null;

        console.error(
          'Unable to load custom-length inventory:',
          error
        );

        return null;
      });

    return customLengthRequest;
  }

  /* ==========================================================
     VARIANT CHANGE EVENTS
  ========================================================== */

  let updateTimer = null;

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
      updateAllLabels();
      updateMainBackorderMessage();
    }, 100);
  }

  document.addEventListener('change', event => {
    if (
      event.target.matches(
        OLD_PICKER + ' input, ' +
        CUSTOM_INPUT + ', ' +
        'form[action*="/cart/add"] [name="id"]'
      )
    ) {
      lastVariantId = null;
      lastQuantity = null;

      scheduleUpdate();

      /*
        One extra check accommodates themes that update the Shopify
        variant ID after the radio change event.
      */

      setTimeout(scheduleUpdate, 300);
    }
  });

  document.addEventListener('click', event => {
    if (
      event.target.closest(OLD_PICKER) ||
      event.target.closest(CUSTOM_PICKER)
    ) {
      lastVariantId = null;
      lastQuantity = null;

      scheduleUpdate();

      setTimeout(scheduleUpdate, 300);
    }
  });

  window.addEventListener('popstate', () => {
    lastVariantId = null;
    lastQuantity = null;

    scheduleUpdate();
  });

  /* ==========================================================
     INITIALIZE — HANDLE DELAYED PRODUCT PICKER RENDERING
  ========================================================== */

  let initializeTimer = null;
  let initializeAttempts = 0;

  const MAX_INITIALIZE_ATTEMPTS = 50;

  function initialize() {
    if (productId) return;

    productId = getProductId();

    // The product container may not exist yet on initial load.
    if (!productId) {
      if (initializeAttempts < MAX_INITIALIZE_ATTEMPTS) {
        initializeAttempts++;
        initializeTimer = setTimeout(initialize, 200);
      }

      return;
    }

    clearTimeout(initializeTimer);

    if (isExcludedProduct()) {
      removeMainNotice();
      return;
    }

    // Start the existing inventory requests only once.
    loadInventory();
    loadCustomLengthInventory();

    /*
      Retry rendering briefly because the theme may render the
      selected variant picker or Add to Cart wrapper after inventory.
    */

    const retryDelays = [
      100,
      300,
      600,
      1000,
      1500,
      2200
    ];

    retryDelays.forEach(delay => {
      setTimeout(() => {
        updateAllLabels();
        updateMainBackorderMessage();
      }, delay);
    });
  }

  function startInitialization() {
    initializeAttempts = 0;
    initialize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startInitialization,
      { once: true }
    );
  } else {
    startInitialization();
  }
})();